import { useQuery } from '@tanstack/react-query';

import { useEventFilters } from '@/hooks';
import { sdk } from '@/services';
const EventService = sdk.getService('EventService');

export const useEventsList = () => {
  const { filters } = useEventFilters();

  const { isLoading, data, error } = useQuery({
    queryKey: ['events', filters],
    queryFn: () => EventService.getAllEvents(filters)
  });

  return {
    events: data,
    isLoading,
    error
  };
};
